// Modals
import { HIDE_LOADING, HIDE_MODAL, SHOW_LOADING, SHOW_MODAL } from '../actionTypes';

export const showModal = (name, payload) => ({type: SHOW_MODAL, payload: {name, payload}});
export const hideModal = name => ({type: HIDE_MODAL, payload: {name}});
export const showLoading = () => ({type: SHOW_LOADING});
export const hideLoading = () => ({type: HIDE_LOADING});
